import BoxShipAnimation from '@assets/lottie/box_ship.json';
import i18n from '@/utils/i18n';
import React from 'react';
import { AnimationView } from '@usepepper/ui/atoms/animation-view';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface CheckoutPanelOrderPlacedProps {
  onClose: () => void;
  restaurantName: string;
}

export const CheckoutPanelOrderPlaced: React.FC<
  CheckoutPanelOrderPlacedProps
> = ({ onClose, restaurantName }) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container}>
      <View style={styles.top}>
        <View style={styles.animationContainer}>
          <AnimationView
            autoPlay
            loop
            source={BoxShipAnimation}
            style={styles.animation}
          />
        </View>
        <View style={styles.content}>
          <Typography color={theme.sk.color.text.primary} variant="heading-md">
            {i18n.t('sales_portal.order_entry.order_placed_modal.title')}
          </Typography>
          <Typography
            color={theme.sk.color.text.secondary}
            variant="paragraph-md"
          >
            {i18n.t('sales_portal.order_entry.order_placed_modal.description', {
              restaurantName,
            })}
          </Typography>
        </View>
      </View>
      <View style={styles.footer}>
        <Button
          accessibilityLabel={i18n.t(
            'sales_portal.order_entry.order_placed_modal.cta',
          )}
          onPress={onClose}
          size={ButtonSize.Medium}
          variant={ButtonVariant.Primary}
          width="100%"
        >
          {i18n.t('sales_portal.order_entry.order_placed_modal.cta')}
        </Button>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  animation: {
    alignSelf: 'center',
    height: 244,
    width: 374,
  },
  animationContainer: {
    backgroundColor: theme.sk.color.bg.highlight.success,
    borderRadius: theme.sk.radii.radiusMedium,
    overflow: 'hidden',
    width: '100%',
  },
  container: {
    alignItems: 'center',
    flex: 1,
    gap: theme.sk.spacing.spaceMedium,
    justifyContent: 'space-between',
  },
  content: {
    gap: theme.sk.spacing.spaceSmall,
    width: '100%',
  },
  footer: {
    alignSelf: 'stretch',
    paddingTop: theme.sk.spacing.spaceSmall,
  },
  top: {
    alignItems: 'center',
    gap: theme.sk.spacing.spaceMedium,
    width: '100%',
  },
}));
